import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Prevent the benign "ResizeObserver loop" error (fired by chart/Gantt relayout) from
// reaching the CRA dev error overlay, which is full-screen fixed and blocks all clicks.
// Defer observer callbacks to the next frame so a relayout can't re-trigger in the same loop.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const Native = window.ResizeObserver;
  window.ResizeObserver = class extends Native {
    constructor(cb) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          if (!Array.isArray(entries) || entries.length) cb(entries, observer);
        });
      });
    }
  };
}
const _roErr = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (e.message && _roErr.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
